<template>
  <a-tag v-if="label !== '-'" class="payment-method-tag" :class="methodClass">{{ label }}</a-tag>
  <span v-else>-</span>
</template>

<script setup>
import { computed } from "vue";
import { formatRecordField, tradeTypePrefix } from "@/utils/orderRecordTypes";

const props = defineProps({
  record: { type: Object, default: null },
  field: { type: Object, required: true },
});
const label = computed(() => formatRecordField(props.record, props.field));
const providerClasses = { airwallex: "method-airwallex", hlb: "method-hlb", kq: "method-kq", apple: "method-apple", huawei: "method-huawei" };
const methodClass = computed(() => {
  const value = props.record?.[props.field.source || props.field.key];
  const provider = props.field.providerTradeType ? tradeTypePrefix(value) : value;
  return Object.hasOwn(providerClasses, provider) ? providerClasses[provider] : "";
});
</script>

<style scoped>
.payment-method-tag { margin-inline-end: 0; padding: 1px 6px; border-radius: 4px; font-size: 12px; line-height: 18px; font-weight: 500; color: #4b5563; background: #f9fafb; border-color: #e5e7eb; white-space: normal; overflow-wrap: anywhere; }
.method-airwallex { color: #6d28d9; background: #f5f3ff; border-color: #ddd6fe; }
.method-hlb { color: #9a3412; background: #fff7ed; border-color: #fed7aa; }
.method-kq { color: #1d4ed8; background: #eff6ff; border-color: #bfdbfe; }
.method-apple { color: #374151; background: #f3f4f6; border-color: #d1d5db; }
.method-huawei { color: #991b1b; background: #fef2f2; border-color: #fecaca; }
</style>
